import React from 'react';
const Photographers = () => <div className="service-page"><h1>Photographers</h1><p>Capture memories with top photographers.</p></div>;
export default Photographers;
